import React from 'react'
import { Row } from 'react-bootstrap'
import ColItem from './colItem'

const LeaseFeesTable = ({
  nlFee,
  spFee,
  fbt,
  lcda,
  erShare,
  erShare_isDisplayed,
  gstOnECM,
  gstOnECM_isDisplayed,
  greenfleet,
  erAdminFee,
  id,
  brand,
}) => (
  <Row>
    <ColItem
      icon="IconDollar3"
      id={`${id}-nlFee`}
      title={`Oly novated leasing`}
      value={nlFee}
      tooltip={{
        text: 'What we charge for taking care of your lease & removing hassle for you at every turn. From negotiating with dealerships to your admin throughout your lease.',
      }}
    />
    <ColItem
      icon="IconDollar3"
      id={`${id}-spFee`}
      title="Salary packaging"
      value={spFee}
      tooltip={{
        text: 'An administration fee agreed upon with your employer, in exchange for managing your salary packaging account.',
      }}
    />
    <ColItem
      icon="IconDollar3"
      id={`${id}-fbt`}
      title="FBT"
      value={fbt}
      tooltip={{
        text: 'Fringe Benefits Tax As your novated lease is a benefit your employer provides outside of your salary or wages, it’s subject to FBT. You may be able to offset any FBT liability by using the Employee Contribution Method.',
      }}
    />

    <ColItem
      icon="IconDollar3"
      id={`${id}-gstOnECM`}
      title="GST on ECM"
      value={gstOnECM}
      isDisplayed={gstOnECM_isDisplayed}
      tooltip={{
        text: 'Because your post-tax contribution (ECM) goes towards running costs, GST is applied as a ‘consumer-based tax’. It’s calculated as a fraction of your ECM (1/11th) and comes out of your post-tax contribution.',
      }}
    />
    <ColItem
      icon="IconDollar3"
      iconSize={2.2}
      id={`${id}-lcda`}
      title="Luxury car depreciation allowance"
      value={lcda}
      tooltip={{
        text: 'If the amount you’re financing is greater than the Luxury Vehicle Limit set by the ATO, your employer can’t claim Income Tax Credits for the full amount of your Novated Lease. LCDA is paid to your employer to compensate them for the portion of your lease they can’t claim.',
      }}
    />
    <ColItem
      icon="IconDollar3"
      id={`${id}-greenfleet`}
      title="Greenfleet donation"
      value={greenfleet}
      tooltip={{
        text: 'An optional donation paid to Greenfleet to offset your carbon emissions by planting trees.',
      }}
    />
    <ColItem
      icon="IconDollar3"
      id={`${id}-erShare`}
      title="Employer share of benefit"
      value={erShare}
      isDisplayed={erShare_isDisplayed}
      tooltip={{
        text: 'A percentage of your novated lease benefit that is paid to your employer',
      }}
    />
    <ColItem
      icon="IconDollar3"
      id={`${id}-erAdminFee`}
      title="Tax share"
      value={erAdminFee}
      tooltip={{
        text: 'The fee paid to your employer for administering your salary package',
      }}
    />
  </Row>
)

export default LeaseFeesTable
